import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";
import { ValuablesProductFormState } from "..";
import { ValuablesPriceRequestInfo } from "../valuablesInterface";

export function mapFormToPriceRequest(
  formValues: ValuablesProductFormState,
): ValuablesPriceRequestInfo {
  return {
    coverageAmount: formValues.coverage_amount,
    valuableType: formValues.product,
    yearOfManufacture: Number(formValues.year),
    description: formValues.description,
    injuries: Number(formValues.injuries),
    injuryYear:
      formValues.injuries !== DamageRecentYears.NONE
        ? Number(formValues.injuryYear)
        : null,
  };
}
